import { Card, TextField, Chip, IconButton, Tooltip } from '@mui/material'
import Grid from '@mui/material/Grid'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Loader from 'examples/Loader'
import { useEffect, useState } from 'react'
import CustomDataTable from '../Users/CustomDataTable'
import CreateBlogModal from './components/CreateBlogModal'
import AppData from './components/data-tables/data/dataTableData'


function Collections() {
  const {
    dataTableData,
    handleRefresh,
    loader,
    pagination,
    handlePageChange,
    handleLimitChange,
    search,
    setSearch,
    handleSearch,
  } = AppData()

  const [typingTimeout, setTypingTimeout] = useState(null)

  const handleDebouncedSearch = (value) => {
    setSearch(value)
    if (value.trim() === '') {
      if (typingTimeout) clearTimeout(typingTimeout)
      handleSearch()
      return
    }
    if (typingTimeout) clearTimeout(typingTimeout)
    const timeout = setTimeout(() => {
      handleSearch()
    }, 1000)
    setTypingTimeout(timeout)
  }

  useEffect(() => {}, [])

  return (
    <DashboardLayout>
      {loader ? (
        <Loader />
      ) : (
        <>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  {/* Header Bar */}
                  <MDBox
                    mx={2}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" color="white">
                      Collections Pages
                    </MDTypography>
                    <CreateBlogModal handleRefresh={handleRefresh} />
                  </MDBox>

                  <MDBox pt={3} px={3}>
                    {/* Search Bar */}
                    {/* <Grid container spacing={2} alignItems="center" mb={2}>
                      <Grid item>
                        <TextField
                          variant="outlined"
                          size="small"
                          placeholder="Search blogs..."
                          value={search}
                          onChange={(e) => handleDebouncedSearch(e.target.value)}
                          sx={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            width: 280,
                          }}
                        />
                      </Grid>
                    </Grid> */}

                    <CustomDataTable
                      table={dataTableData}
                      canSearch={false}
                      entriesPerPage={{
                        defaultValue: pagination?.limit || 10,
                        entries: [5, 10, 15, 20, 25],
                      }}
                      pagination={pagination}
                      onPageChange={handlePageChange}
                      onLimitChange={handleLimitChange}
                    />
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </DashboardLayout>
  )
}

export default Collections
